import React, { Component } from "react";
import Slider from "react-slick";
import Image from "next/image";

const VlsiSlider = (props) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <Slider {...settings}>
      <div className="slider-div">
        <div className="flex flex-1 flex-col justify-center lg:px-10  2xl:px-28">
        <p className="font-headline font-extrabold text-5xl 2xl:text-7xl">
        Seamless, Secure, Scalable: <br/> Your Digital Landscape Refined
          </p>
          <p className="font-headline  text-2xl 2xl:text-3xl mt-2">
          Building Tomorrow's Infrastructure Today
          </p>
        </div>
        <div className="flex w-2/4">
          <Image
            alt="slider image"
            src="/images/VLSI/slider1.png"
            height="860"
            width="1000"
            layout="intrinsic"
            priority="true"
          />
        </div>
      </div>
      <div className="slider-div">
        <div className="flex flex-1 flex-col justify-center lg:px-10  2xl:px-28">
          <p className="font-headline font-extrabold text-5xl 2xl:text-7xl">
          The Art of Firmware & Simulation, Where Ideas Become Reality
          </p>
        </div>
        <div className="flex w-2/4">
          <Image
            src="/images/VLSI/slider2.png"
            alt="slider image"
            height="860"
            width="1000"
            layout="intrinsic"
            priority="true"
          />
        </div>
      </div>
      <div className="slider-div">
        <div className="flex flex-1 flex-col justify-center lg:px-10  2xl:px-28">
          <p className="font-headline font-extrabold text-5xl 2xl:text-7xl">
          From Concept to Reality, Your Digital Backend Partner
          </p>
        </div>
        <div className="flex w-2/4">
          <Image
            src="/images/VLSI/slider3.png"
            height="860"
            width="1000"
            layout="intrinsic"
            alt="slider image"
            priority="true"
          />
        </div>
      </div>
      <div className="slider-div">
        <div className="flex flex-1 flex-col justify-center lg:px-10  2xl:px-28">
          <p className="font-headline font-extrabold text-5xl 2xl:text-7xl">
            Designing Excellence, Verifying Innovation
          </p>
          <p className="font-headline text-2xl 2xl:text-3xl mt-2">
            for Next-gen IoT, 5G, and Smart Devices
          </p>
        </div>
        <div className="flex w-2/4">
          <Image
            src="/images/VLSI/slider4.png"
            height="860"
            width="1000"
            layout="intrinsic"
            alt="slider image"
            priority="true"
          />
        </div>
      </div>
      <div className="slider-div">
        <div className="flex flex-1 flex-col justify-center lg:px-10  2xl:px-28">
        <p className="font-headline font-extrabold text-5xl 2xl:text-7xl">
        Safeguarding the Heart of Your Innovation 
          </p>
          <p className="font-headline text-2xl 2xl:text-3xl mt-2">
          IC Packaging Excellence,Where Precision Meets Protection
          </p>
        </div>
        <div className="flex w-2/4">
          <Image
            src="/images/VLSI/slider5.png"
            height="860"
            width="1000"
            layout="intrinsic"
            alt="slider image"
            priority="true"
          />
        </div>
      </div>
    </Slider>
  );
};

export default VlsiSlider;
